// extracted by mini-css-extract-plugin
export default {"modalClose":"modal_modalClose__4C5N0","modalContent":"modal_modalContent__IDOrz","modalHeader":"modal_modalHeader__BUj3g"};